// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCcKJK1sne8Q-c-mf8eYD2x1nCuxBFOa24",
  authDomain: "hotplotz-b9688.firebaseapp.com",
  projectId: "hotplotz-b9688",
  storageBucket: "hotplotz-b9688.firebasestorage.app",
  messagingSenderId: "1069084103649",
  appId: "1:1069084103649:web:032be4c50a959515ed78a0",
  measurementId: "G-077DCVQYCN"

};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { messaging, getToken, onMessage };